import { useLocalStorage } from '@buffer-mono/popcorn'

export const SIDEBAR_CHANNELS_COUNT_STORAGE_KEY = 'sidebar-channels-last-count'

const DEFAULT_SKELETON_ROWS = 5
const MAX_SKELETON_ROWS = 8

type SetLastChannelsCount = (count: number) => void

/**
 * The channel count this browser last saw, persisted so the channels
 * loading skeleton can reserve the same number of rows on the next page
 * load. This is a rendering hint only — after an org switch or a channel
 * change it is wrong for one load and then corrected.
 */
export function useLastChannelsCount(): [number | null, SetLastChannelsCount] {
  const [count, setCount] = useLocalStorage<number | null>(
    SIDEBAR_CHANNELS_COUNT_STORAGE_KEY,
    null,
  )
  return [count, setCount]
}

/**
 * Rows the channels skeleton should reserve for a remembered channel count.
 * Zero channels maps to one row because the loaded section then shows the
 * compact connect-channels group. Accounts with three or fewer channels
 * also show the connect-more block, which is about one row tall.
 */
export function channelsSkeletonRows(count: number | null): number {
  if (count === null) return DEFAULT_SKELETON_ROWS
  if (count === 0) return 1
  const suggestionRows = count <= 3 ? 1 : 0
  return Math.min(count + suggestionRows, MAX_SKELETON_ROWS)
}
